<script lang="ts">
  import FilterEditor from "app/settings/filters/FilterEditor.svelte";
  import type { SearchFilter } from "module/store/Filters";

  let { filter }: { filter: SearchFilter } = $props();
</script>

<FilterEditor filterConfig={filter.filterConfig} on:change></FilterEditor>

<style>
</style>
